export default "__VITE_ASSET__CwyoIHx2__"